export default __webpack_public_path__ + "static/media/google-30x30.d8bfaa65.svg";